import { makeVar } from '@apollo/client';
import { useReactiveVar } from '@apollo/client/react';
import { useMediaQuery, useTheme } from '@mui/material';
import { useGlobalDrawer } from 'src/layouts';

export const PAGE_OUTLINE_CLOSED_WIDTH_PX = 96;

const OUTLINE_WIDTH_CONFIG = {
  baseWidth: 220,
  breakpointsPx: {
    0: { drawerWidth: 220, screen: 1024 },
    1: { drawerWidth: 260, screen: 1280 },
    2: { drawerWidth: 300, screen: 1440 },
    3: { drawerWidth: 340, screen: 1680 },
    4: { drawerWidth: 380, screen: 1920 },
    5: { drawerWidth: 420, screen: 2560 },
  },
} as const;

function getIsBreakpointIndex(
  index: number
): index is keyof typeof OUTLINE_WIDTH_CONFIG.breakpointsPx {
  return index in OUTLINE_WIDTH_CONFIG.breakpointsPx;
}

export function useOutlineWidthBasedOnBreakpoint(): number {
  const theme = useTheme();
  const { isOpen: isGlobalDrawerOpen } = useGlobalDrawer();
  const breakpoints = [
    useMediaQuery(theme.breakpoints.up(OUTLINE_WIDTH_CONFIG.breakpointsPx[0].screen), {
      noSsr: true,
    }),
    useMediaQuery(theme.breakpoints.up(OUTLINE_WIDTH_CONFIG.breakpointsPx[1].screen), {
      noSsr: true,
    }),
    useMediaQuery(theme.breakpoints.up(OUTLINE_WIDTH_CONFIG.breakpointsPx[2].screen), {
      noSsr: true,
    }),
    useMediaQuery(theme.breakpoints.up(OUTLINE_WIDTH_CONFIG.breakpointsPx[3].screen), {
      noSsr: true,
    }),
    useMediaQuery(theme.breakpoints.up(OUTLINE_WIDTH_CONFIG.breakpointsPx[4].screen), {
      noSsr: true,
    }),
    useMediaQuery(theme.breakpoints.up(OUTLINE_WIDTH_CONFIG.breakpointsPx[5].screen), {
      noSsr: true,
    }),
  ];
  const lastMatchingIndex = breakpoints.lastIndexOf(true);
  if (!getIsBreakpointIndex(lastMatchingIndex) || isGlobalDrawerOpen)
    return OUTLINE_WIDTH_CONFIG.baseWidth;

  return OUTLINE_WIDTH_CONFIG.breakpointsPx[lastMatchingIndex].drawerWidth;
}

/**
 * Is page outline open
 */
export const isPageOutlineOpenVar = makeVar<boolean>(false);

export function useIsPageOutlineOpen() {
  const isPageOutlineOpen = useReactiveVar(isPageOutlineOpenVar);
  return { isPageOutlineOpen };
}

export function setIsPageOutlineOpen(isOpen: boolean) {
  isPageOutlineOpenVar(isOpen);
}
